import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  public BaseURL: string;

  constructor() {}

  URLEncode(data: any): string {
    if (data === undefined || data === null) {
      return '';
    }

    return encodeURIComponent(data);
  }

  formatDate(date): DateTime | null {
    return date
      ? DateTime.fromISO(date) /*.toLocaleString(DateTime.DATETIME_MED)*/
      : null;
  }
}
